import React, { useEffect } from "react";
import "./styles.css";
import { useHistory, useParams, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { requestActualURL } from "common/features/tinyURL/tinyURLActions";
import { RootState } from "common/rootReducer";
const TinyURL = () => {
  let { tinyURLId } = useParams<any>();
  const dispatch = useDispatch();
  const location = useLocation<any>();
  const history = useHistory();

  const tinyURLLoading = useSelector(
    (state: RootState) => state.tinyURL.tinyURLLoading
  );
  const tinyURLSuccess = useSelector(
    (state: RootState) => state.tinyURL.tinyURLSuccess
  );
  const tinyURLFailure = useSelector(
    (state: RootState) => state.tinyURL.tinyURLFailure
  );
  const tinyURLResponse = useSelector(
    (state: RootState) => state.tinyURL.MetaResult?.metaDataInfo.responseMessage
  );

  useEffect(() => {
    if (!/\d/.test(tinyURLId)) {
      history.push("/restaurant/" + tinyURLId + "/details");
    }
  }, [tinyURLId]);

  useEffect(() => {
    const tinyURLRequest = {
      tinyUrl: tinyURLId,
    };
    dispatch(requestActualURL(tinyURLRequest));
  }, []);

  useEffect(() => {
    if (!tinyURLLoading && tinyURLSuccess) {
      window.open(tinyURLResponse, "_self");
    }
  }, [tinyURLLoading]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Poppins",
        fontWeight: 500,
        height: "100vh",
      }}
    >
      <div
        style={{ textAlign: "center", fontSize: "0.8em", marginBottom: "40%" }}
      >
        {tinyURLLoading && (
          <p style={{ color: "#525252", fontFamily: "Poppins" }}>Loading...</p>
        )}{" "}
        {tinyURLFailure && (
          <p style={{ color: "#525252", fontFamily: "Poppins" }}>
            Link expired..
          </p>
        )}
      </div>
    </div>
  );
};
export default TinyURL;
